import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ProfileManagementAPI } from "components/Apis/userManagement";
import UserProfile from "../../components/UserProfile/UserProfile";

const OPERATING_USER_STORAGE_KEY = "operating_user";

const readStoredOperatingUser = () => {
    try {
        const raw = localStorage.getItem(OPERATING_USER_STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

const writeStoredOperatingUser = (user) => {
    try {
        localStorage.setItem(OPERATING_USER_STORAGE_KEY, JSON.stringify(user ?? null));
    } catch {
        // Ignore storage write errors (private mode, quota, etc.)
    }
};

const clearStoredOperatingUser = () => {
    try {
        localStorage.removeItem(OPERATING_USER_STORAGE_KEY);
    } catch {
        // Ignore storage remove errors
    }
};

export const fetchOperatingUser = createAsyncThunk("navigationState/fetchUser", async () => {
    try {
        const response = await ProfileManagementAPI.getOperatingUser();
        writeStoredOperatingUser(response.data);
        return response.data;
    } catch (error) {
        clearStoredOperatingUser();
        UserProfile.logout();
        throw new Error("Failed to fetch operating user");
    }
});

const stateSlice = createSlice({
    name: "navigationState",
    initialState: {
        user: {
            data: readStoredOperatingUser(),
            loading: false,
            error: null,
        }
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchOperatingUser.pending, (state) => {
                state.user.loading = true;
                state.user.error = null;
            })
            .addCase(fetchOperatingUser.fulfilled, (state, action) => {
                state.user.loading = false;
                state.user.data = action.payload;
            })
            .addCase(fetchOperatingUser.rejected, (state, action) => {
                state.user.loading = false;
                state.user.data = null;
                state.user.error = action.error.message;
            });
    },
});

export default stateSlice.reducer;
